import { Extension } from '@tiptap/core';

const FontSize = Extension.create({
  name: 'fontSize',
  addOptions() { return { types: ['textStyle'], }; },
  addGlobalAttributes() { return [ { types: ['textStyle'], attributes: { fontSize: { default: null, parseHTML: element => element.style.fontSize?.replace(/['"]+/g, ''), renderHTML: attributes => { if (!attributes.fontSize) { return {}; } return { style: `font-size: ${attributes.fontSize}`, }; }, }, }, }, ]; },
  addCommands() { return { setFontSize: fontSize => ({ chain }) => { return chain().setMark('textStyle', { fontSize }).run(); }, }; },
});

export default FontSize;
